import styled from 'styled-components';
import { key } from 'styled-theme';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-columns: 2fr 1.3fr;
  align-items: center;
`;

export const LeftSection = styled.div`
  flex: 1;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  height: 100vh;

  @media (max-width: 1024px) {
    padding: 2rem;
    background: rgba(0, 0, 0, 0.6);
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: auto;
    min-height: 100vh;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
`;

export const Title = styled.h1`
  color: white;
  font-size: 3rem;
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 3rem;
  align-self: center;

  @media (max-width: 1200px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    text-align: center;
    max-width: none;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 300px;
    align-items: center;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-align: left;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 1rem 1.25rem;
    font-size: 1rem;
    justify-content: center;
    text-align: center;
  }
`;

export const ButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: white;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ButtonText = styled.span`
  color: white;
  font-weight: 600;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

// Alternative layout for mobile-first approach
export const MobileContainer = styled.div`
  @media (max-width: 768px) {
    ${Container} {
      flex-direction: column;
    }

    ${LeftSection} {
      display: none;
    }

    ${RightSection} {
      width: 100%;
      height: 100vh;
      justify-content: center;
      align-items: center;
    }
  }
`;
